<template>
  <div class="grid min-h-screen grid-rows-[1fr_auto]">
    <div class="flex parent-wrapper">
      <PageSidebar v-if="user?.isAdmin" />
      <div class="flex-1 min-w-0">
        <TheHeader />
        <main class="py-20">
          <slot />
        </main>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script setup lang="ts">
const { user } = useUserSession();
</script>

<style>
/* .dark {
  .parent-wrapper {
    background:
      radial-gradient(ellipse at top, var(--color-primary), transparent),
      radial-gradient(ellipse at bottom, var(--color-secondary), transparent);
  }
}

.light {
  .parent-wrapper {
    background:
      radial-gradient(ellipse at top, var(--color-secondary-100), transparent),
      radial-gradient(
        ellipse at bottom,
        var(--ui-color-primary-200),
        transparent
      );
  }
} */
</style>
